var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronChev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    transform: "translate(-0.000488281 0.251953)",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8329 33.3075L35.3174 39.7633L33.9309 41.212L24.9594 32.2315L33.8902 23.292L35.2759 24.6995L28.7506 31.2387L27.8394 32.2315L28.8329 33.3075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6793 55.322C18.7614 55.322 8.28934 44.8499 8.28934 31.932C8.28934 19.014 18.7614 8.54199 31.6793 8.54199C44.5973 8.54199 55.0693 19.0141 55.0693 31.932C55.0693 44.8499 44.5973 55.322 31.6793 55.322Z",
    stroke: "white",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronChev);
export default __webpack_public_path__ + "static/media/Chevron-chev.f59b0d01396e6bd5f3ac984fb87d6afe.svg";
export { ForwardRef as ReactComponent };